import { render, staticRenderFns } from "./Sandan.vue?vue&type=template&id=5d384da2&scoped=true&"
import script from "./Sandan.vue?vue&type=script&lang=js&"
export * from "./Sandan.vue?vue&type=script&lang=js&"
import style0 from "./Sandan.vue?vue&type=style&index=0&id=5d384da2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d384da2",
  null
  
)

export default component.exports